export const UNKNOWN_NODE = 'unknown';

export const getIssueNodeName = (issue) =>
  issue.node_name || UNKNOWN_NODE;


// WEBPACK FOOTER //
// src/helpers/nodeIssues.js